import { memo, useMemo } from 'react';
import { Marker } from '@adamscybot/react-leaflet-component-marker';
import { HospitalMarkerType } from '@lp/features/RoutePlanner/types';
import { MapPointIcon } from '@icons';
import { OrganType } from '@/api/apis/case';
import { ORGAN_ICON } from '@/utils/helpers';

export const DonorHospitalMarker = memo(({ location, organType }: HospitalMarkerType & { organType: OrganType }) => {
  const icon = useMemo(() => {
    const Icon = ORGAN_ICON[organType];

    return (
      <div className="relative flex flex-col justify-center items-center -translate-y-1/3">
        <div className="relative text-warning-40 mt-0.5 overflow-hidden">
          <MapPointIcon />
          <div className="absolute text-white top-1 left-[2px]">
            <Icon width={19} height={19} />
          </div>
        </div>
        <div className="box-border w-3 h-3 rounded-full border-3 bg-white border-warning-40" />
      </div>
    );
  }, [organType]);

  return (
    <Marker
      position={location}
      zIndexOffset={40}
      componentIconOpts={{
        disableClickPropagation: true,
      }}
      icon={icon}
    />
  );
});
